<script setup name="TvbHomeMytvSuper">
import request from '@/utils/request'
import TvbHomeSmallBannerTemplateThree from './../SmallBanner/components/TemplateThree/index.vue'
import { reactive, inject } from 'vue'
const size = inject('size')
const props = defineProps({
  info: {
    type: Object,
    default: null
  }
})

const mytvSuper = reactive({
  moreUrl: null,
  big: null,
  list: []
})

if (props.info.api) {
  request({
    url: props.info.api,
    method: 'get'
  }).then(({ data }) => {
    let { list, more_url } = data
    mytvSuper.big = list[0]
    mytvSuper.list = list.slice(1, 5)
    mytvSuper.moreUrl = more_url
  })
}
</script>

<template>
  <section class="tvb-home-mytv-super" v-if="mytvSuper.list.length" :class="[size]">
    <header class="tvb-home-mytv-super-header">
      <h2 class="tvb-home-mytv-super-title">
        <component
          :is="mytvSuper?.moreUrl ? 'tvb-router-link' : 'span'"
          :link-target="2"
          :to="mytvSuper?.moreUrl"
        >
          {{ info.title }}
        </component>
      </h2>
      <!-- && mytvSuper.list.length > 4 -->
      <tvb-button
        v-if="mytvSuper.moreUrl"
        :style="{ '--tvb-button-height': ['s', 'xs'].includes(size) ? '24px' : '36px' }"
        class="tvb-home-mytv-super_more"
        :type="!['s', 'xs'].includes(size) ? 'more' : 'more-text'"
        :animation="!['s', 'xs'].includes(size) ? 'more' : ''"
        icon="icon_list_arrow_grey"
        :path="mytvSuper.moreUrl"
        :link-target="2"
        >查看更多</tvb-button
      >
    </header>
    <tvb-home-small-banner-template-three
      :link-target="2"
      :info="props.info"
      :big="mytvSuper.big"
      :list="mytvSuper.list"
    />
  </section>
</template>

<style lang="scss" scoped>
.tvb-home-mytv-super {
  min-width: 320px;
  .tvb-home-mytv-super-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tvb-home-mytv-super-title {
      font-size: 24px;
      font-weight: 500;
      color: #1e1e1e;
      line-height: 36px;
      letter-spacing: 0.5px;
      > a {
        text-decoration: none;
        color: inherit;
        transition: color 0.15s linear;
        &:hover {
          color: rgba(0, 98, 163, 1);
        }
      }
    }
    :deep(.tvb-home-mytv-super_more) {
      &.btn-more .svg-icon {
        margin-left: 1px;
      }
    }
  }

  &.s {
    .tvb-home-mytv-super-header {
      padding: 0 16px;
    }
  }
  &.s,
  &.xs {
    .tvb-home-mytv-super-header {
      padding: 0 12px;
      align-items: center;
      .tvb-home-mytv-super-title {
        font-size: 17px;
        font-weight: 500;
        color: #1e1e1e;
        line-height: 24px;
      }
    }
  }
}
</style>
